<template>
  <div class="w-screen h-body">
    <div class="w-full h-full flex flex-col items-center justify-center gap-8">
      <div class="font-logo font-bold text-center">
        <div class="text-6xl">404</div>
        <div class="text-2xl">Page Not Foünd</div>
      </div>
      <router-link to="/clients" class="font-semibold text-light-purple-400 hover:text-dark-purple-200">
        Back to home
      </router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: "NotFound"
};
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue